import GoTrue from "gotrue-js";

export default new GoTrue({
  APIUrl: process.env.VUE_APP_AUTH_API_URL,
  audience: "",
  setCookie: true,
});
